export const GRID_V1_FORMAT = 'grid-v1' as const;

export interface GridV1GridOptions {
  column?: number;
  cellHeight?: number | string;
  margin?: number;
}

export const GRID_V1_CELL_FORMATS = [
  'markdown-v1',
  'np-map',
  'np-message',
] as const;

export type GridV1CellFormat = (typeof GRID_V1_CELL_FORMATS)[number];

export interface GridV1Widget {
  id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
  format: GridV1CellFormat;
  value: string;
}

export interface GridV1DocumentValue {
  version: 1;
  grid: GridV1GridOptions;
  widgets: GridV1Widget[];
}

export const DEFAULT_GRID_V1_GRID_OPTIONS: GridV1GridOptions = {
  column: 12,
  cellHeight: 80,
  margin: 8,
};

export const DEFAULT_GRID_V1_CELL_ID = 'cell-1';

export function createDefaultGridV1DocumentValue(): GridV1DocumentValue {
  return {
    version: 1,
    grid: { ...DEFAULT_GRID_V1_GRID_OPTIONS },
    widgets: [
      {
        id: DEFAULT_GRID_V1_CELL_ID,
        x: 0,
        y: 0,
        w: 12,
        h: 4,
        format: 'markdown-v1',
        value: '',
      },
    ],
  };
}

/** Layout fields passed to GridStack `load()` (no cell content). */
export type GridV1LayoutWidget = Omit<GridV1Widget, 'format' | 'value'> & {
  format?: never;
  value?: never;
};

export function toLayoutWidgets(widgets: GridV1Widget[]): GridV1LayoutWidget[] {
  return widgets.map((widget) => {
    const { id, x, y, w, h, minW, minH } = widget;
    return {
      id,
      x,
      y,
      w,
      h,
      ...(minW !== undefined ? { minW } : {}),
      ...(minH !== undefined ? { minH } : {}),
    };
  });
}
